export const REQUEST_FAVORITES_DATA: 'FAVORITES/REQUEST_FAVORITES_DATA' = 'FAVORITES/REQUEST_FAVORITES_DATA';
export const REQUEST_FAVORITES_META_DATA_SUCCESS: 'FAVORITES/REQUEST_FAVORITES_META_DATA_SUCCESS' =
	'FAVORITES/REQUEST_FAVORITES_META_DATA_SUCCESS';
export const REQUEST_FAVORITES_DATA_SUCCESS: 'FAVORITES/REQUEST_FAVORITES_DATA_SUCCESS' =
	'FAVORITES/REQUEST_FAVORITES_DATA_SUCCESS';
export const REQUEST_FAVORITES_DATA_FAILURE: 'FAVORITES/REQUEST_FAVORITES_DATA_FAILURE' =
	'FAVORITES/REQUEST_FAVORITES_DATA_FAILURE';
export const REQUEST_SELECTED_FAVORITE_DATA: 'FAVORITES/REQUEST_SELECTED_FAVORITE_DATA' =
	'FAVORITES/REQUEST_SELECTED_FAVORITE_DATA';
export const REQUEST_SELECTED_FAVORITE_DATA_SUCCESS: 'FAVORITES/REQUEST_SELECTED_FAVORITE_DATA_SUCCESS' =
	'FAVORITES/REQUEST_SELECTED_FAVORITE_DATA_SUCCESS';
export const REQUEST_SELECTED_FAVORITE_DATA_FAILURE: 'FAVORITES/REQUEST_SELECTED_FAVORITE_DATA_FAILURE' =
	'FAVORITES/REQUEST_SELECTED_FAVORITE_DATA_FAILURE';
